export default {
  data () {
    return {
      filterTableOptions: {},
      extraInfo: {},
      sortTableStatus: {}
    }
  },
  methods: {
    setTableInfoToHistory () {
      const scrollY = document.querySelector('.root-body').scrollTop

      if (this.filtersList) {
        this.filtersList.forEach((filterItem) => {
          Object.keys(this.selectedFilters).forEach((item) => {
            if (filterItem.field === item) {
              this.selectedFilters[item] = {
                ...this.selectedFilters[item],
                field: filterItem.field,
                name: filterItem.name,
                type: filterItem.type
              }
            }
          })
        })
      }

      history.replaceState({
        data: this.data,
        page: this.page,
        filterTableOptions: this.filterTableOptions,
        extraInfo: this.extraInfo,
        selectedFilters: this.selectedFilters,
        sortTableStatus: this.sortTableStatus,
        filtersList: this.filtersList || [],
        columnsLabel: this.columnsLabel,
        filters: this.filters,
        sorts: this.sorts,
        scrollY
      }, '')
    },
    getTableInfoFromHistory () {
      const config = history.state
      this.data = config.data
      this.page = config.page
      this.filters = config.filters
      this.sorts = config.sorts
      this.selectedFilters = config.selectedFilters
      this.filterTableOptions = config.filterTableOptions
      this.sortTableStatus = config.sortTableStatus
      this.columnsLabel = config.columnsLabel
      this.extraInfo = config.extraInfo
      this.filtersList = config.filtersList

      if (config.selectedFilters) {
        Object.keys(config.selectedFilters).forEach((key) => {
          if (key.startsWith('attr-')) {

            // eslint-disable-next-line prefer-const
            let filter = {
              ...config.selectedFilters[key],
              filterDefault: config.selectedFilters[key].search
            }
            if (filter.type === 'checkbox') {
              filter.types = config.selectedFilters[key].search
            }
            const filtersListIndex = this.filtersList.map(elm => elm.field).indexOf(key)
            if (filtersListIndex > -1) {
              this.filtersList[filtersListIndex] = filter
            }
            // this.filtersList.push(filter)
          } else {
            const columnIndex = this.columnsLabel.map(elm => elm.field).indexOf(key)
            this.columnsLabel[columnIndex].filterDefault = config.selectedFilters[key].search
            if (this.columnsLabel[columnIndex].filterType === 'checkbox') {
              this.columnsLabel[columnIndex].filterTypes = config.selectedFilters[key].search
            }
          }
        })
      }

      this.$nextTick(() => {
        document.querySelector('.root-body').scrollTop = config.scrollY
      })
    },
    setProfileStatus (status) {
      history.pushState({
        status
      }, '')
    },
    getProfileStatus () {
      return history.state.status || ''
    }
  }
}
